// extracted by mini-css-extract-plugin
module.exports = {"article":"Article__article"};